import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import {
  AUTH_STORAGE_KEYS,
  authTotpSetup,
  clearAuthFlow,
  getAuthValue,
  setAuthFlowStep,
} from "../api/authApi";

export default function TotpSetup() {
  const navigate = useNavigate();

  const [qrCode, setQrCode] = useState("");
  const [manualCode, setManualCode] = useState("");
  const [error, setError] = useState("");

  const setupToken = getAuthValue(AUTH_STORAGE_KEYS.setupToken);

  useEffect(() => {
    if (!setupToken) {
      setError("Setup token is missing. Please log in again.");
      return navigate("/");
    }

    const fetchQrCode = async () => {
      try {
        setError("");
        const data = await authTotpSetup(setupToken);
        setQrCode(data.qrCode);
        setManualCode(data.manualCode);
      } catch (e) {
        setError(e.message || "Failed to load QR code.");
      }
    };

    setAuthFlowStep("totp_setup");
    fetchQrCode();
  }, [setupToken, navigate]);

  const handleNavigation = (path, step) => {
    setAuthFlowStep(step);
    navigate(path);
  };

  return (
    <AuthShell
      title="Set up authenticator"
      subtitle="Scan the QR code with your authenticator app or use the manual code below."
    >
      {error && <div className="mb-4 text-[12px] text-red-600 text-center">{error}</div>}

      <div className="flex flex-col items-center">
        <div className="w-[210px] h-[210px] border border-[#d7d7d7] rounded-[12px] bg-[#fafafa] flex items-center justify-center mb-[16px]">
          {qrCode ? (
            <img
              src={qrCode}
              alt="QR code"
              className="w-[180px] h-[180px] rounded-[8px]"
            />
          ) : (
            <div className="w-[170px] h-[170px] bg-[#e8e8e8] rounded-[8px] animate-pulse" />
          )}
        </div>

        <div className="w-full bg-[#f6f6f6] border border-[#e2e2e2] rounded-[10px] px-[14px] py-[12px] mb-[16px]">
          <div className="text-[12px] text-[#777] mb-[6px]">Manual code</div>
          <div className="text-[14px] font-semibold tracking-[1.5px] text-[#3d3935] break-all">
            {manualCode || <span className="text-[#ccc]">Loading...</span>}
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={() => handleNavigation("/2fa/confirm", "totp_confirm")}
        className="w-full h-[44px] bg-[#3d3935] border border-[#0f61a1] text-white px-[20px] mt-[6px] inline-block text-center rounded-[20px] text-[13px] cursor-pointer transition-opacity duration-150 hover:opacity-80"
      >
        I have added it
      </button>

      <button
        type="button"
        onClick={() => {
          clearAuthFlow();
          navigate("/");
        }}
        className="w-full h-[44px] bg-transparent border border-[#d2d2d2] text-[#3d3935] px-[20px] mt-[10px] inline-block text-center rounded-[20px] text-[13px] cursor-pointer transition-opacity duration-150 hover:opacity-80"
      >
        Back
      </button>
    </AuthShell>
  );
}